document.addEventListener("DOMContentLoaded", () => {
  const stickyElement = document.querySelector(".product__images-inner");
  const breadcrumbsWrapper = document.querySelector(".breadcrumbs__wrapper");
  const breadcrumbs = document.querySelector('[aria-label="breadcrumbs"]');
  const breadcrumbsHeight = breadcrumbsWrapper.offsetHeight;
  const breadcrumbsLeft = breadcrumbs.offsetLeft;

  breadcrumbsWrapper.style.height = `${breadcrumbsHeight}px`;

  function checkStickyPosition() {
    const rect = stickyElement.getBoundingClientRect();
    const breadcrumbsMainLeft = breadcrumbsWrapper.offsetLeft + breadcrumbsLeft;

    if (window.scrollY === 0) {
      breadcrumbs.style.position = "";
      breadcrumbs.style.left = "";
    } else if (rect.top < 165) {
      breadcrumbs.style.position = "";
      breadcrumbs.style.left = "";
    } else {
      breadcrumbs.style.position = "fixed";
      breadcrumbs.style.left = `${breadcrumbsMainLeft}px`;
    }
  }

  const observerHeight = new MutationObserver(checkDocumentHeight);

  observerHeight.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
  });

  let lastHeight = document.body.scrollHeight;

  function checkDocumentHeight() {
    const currentHeight = document.body.scrollHeight;
    if (currentHeight !== lastHeight) {
      lastHeight = currentHeight;
      checkStickyPosition();
    }
  }

  window.addEventListener("scroll", checkStickyPosition);

  function handleCheckboxChange() {
    const selectedItem = document.querySelectorAll(".product__checkbox-input");
    const newParam = document.querySelector(".sticky-add-to-cart__param");
    const comparePrise = document.querySelector(
      ".sticky-add-to-cart__compare-price"
    );
    const newPrice = document.querySelector(".sticky-add-to-cart__price");
    const staticBtn = document.querySelector(
      "#addToCart-klaviyo span.js-cart-btn-message__price"
    );
    const staticBtnComparePrise = document.querySelector(
      "#addToCart-klaviyo s.js-cart-btn-message__compare-price"
    );

    selectedItem.forEach((input) => {
      input.addEventListener("change", (event) => {
        // trackCheckedRadios();
        if (input.checked) {
          // newParam.textContent = event.target.value;
          // newPrice.textContent = event.target.dataset.price;
          // staticBtn.textContent = event.target.dataset.price;

          if (comparePrise) {
            // comparePrise.textContent = event.target.dataset.comparePrice;
          }

          if (staticBtnComparePrise) {
            // staticBtnComparePrise.textContent =
            //   event.target.dataset.comparePrice;
          }
        }
      });
    });
  }

  handleCheckboxChange();

  function trackCheckedRadios() {
    const container = document.querySelector("[data-widget-container-wrapper]");
    if (!container) return;

    const radios = container.querySelectorAll('input[type="radio"]');
    const newPrice = document.querySelector(".sticky-add-to-cart__price");
    const staticBtn = document.querySelector(
      "#addToCart-klaviyo span.js-cart-btn-message__price"
    );

    // radios.forEach((radio) => {
    //   if (radio.checked) {
    //     setTimeout(function () {
    //       const priceSpan = radio
    //         .closest("label")
    //         .querySelector("span.rc-option__price");
    //       if (priceSpan) {
    //         const price = priceSpan.textContent.trim();
    //         newPrice.textContent = price;
    //         staticBtn.textContent = price;
    //       }
    //     }, 100);
    //   }
    //   radio.addEventListener("change", () => {
    //     if (radio.checked) {
    //       const priceSpan = radio
    //         .closest("label")
    //         .querySelector("span.rc-option__price");
    //       if (priceSpan) {
    //         const price = priceSpan.textContent.trim();
    //         newPrice.textContent = price;
    //         staticBtn.textContent = price;
    //       }
    //     }
    //   });
    // });
  }

  const observeContainer = () => {
    const targetNode = document.body;
    const config = { childList: true, subtree: true };

    const observerCallback = (mutationsList, observer) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === "childList") {
          const container = document.querySelector(
            "[data-widget-container-wrapper]"
          );
          if (container) {
            trackCheckedRadios();
            observer.disconnect();
          }
        }
      });
    };

    const observer = new MutationObserver(observerCallback);
    observer.observe(targetNode, config);
  };

  observeContainer();

  const targetButton = document.getElementById("addToCart-klaviyo");
  const imageToObserve = document.querySelector(".product__images-carousel");
  const banner = document.getElementById("StickyAddToCart");

  const observerSticky = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const iframeBtn = document.querySelector("#attentive_creative");
        const iframeBtn2 = document.querySelector("#kustomer-ui-sdk-iframe");

        if (!entry.isIntersecting) {
          banner.classList.remove("sticky-add-to-cart__hidden");
          if (iframeBtn) {
            iframeBtn.style.setProperty(
              "transform",
              `translateY(-${banner.clientHeight - 21}px)`
            );
          }
          if (iframeBtn2) {
            iframeBtn2.style.setProperty(
              "transform",
              `translateY(-${banner.clientHeight - 28}px)`
            );
          }
        } else {
          banner.classList.add("sticky-add-to-cart__hidden");
          if (iframeBtn) {
            iframeBtn.style.setProperty("transform", "translateY(0)");
          }
          if (iframeBtn2) {
            iframeBtn2.style.setProperty("transform", "translateY(0)");
          }
        }
      });
    },
    {
      root: null,
      threshold: 0.1,
    }
  );

  observerSticky.observe(targetButton);

  const targetNode = document.body;
  const config = {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["style"],
  };
  let iframeBtnReady = false;

  const mutationCallback = (mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList" || mutation.type === "attributes") {
        const iframeBtn = document.querySelector("#attentive_creative");
        if (iframeBtn) {
          const bottomValue = parseFloat(iframeBtn.style.bottom);
          if (bottomValue) {
            if (banner.classList.contains("sticky-add-to-cart__hidden")) {
              iframeBtn.style.setProperty("transform", "translateY(0)");
            } else {
              iframeBtn.style.setProperty(
                "transform",
                `translateY(-${banner.clientHeight - 21}px)`
              );
            }
          } else {
            iframeBtn.style.setProperty("transform", "translateY(0)");
          }
        }

        const iframeBtn2 = document.querySelector("#kustomer-ui-sdk-iframe");
        if (iframeBtn2) {
          const bottomValue = parseFloat(iframeBtn2.style.bottom);
          if (bottomValue > 10) {
            if (banner.classList.contains("sticky-add-to-cart__hidden")) {
              iframeBtn2.style.setProperty("transform", "translateY(0)");
            } else {
              iframeBtn2.style.setProperty(
                "transform",
                `translateY(-${banner.clientHeight - 28}px)`
              );
            }
          } else {
            iframeBtn2.style.setProperty("transform", "translateY(0)");
          }
        }
      }
    }
  };

  const mutationObserver = new MutationObserver(mutationCallback);
  mutationObserver.observe(targetNode, config);

  const updateButtonClass = () => {
    const imageRect = imageToObserve.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (imageRect.top <= 0 && imageRect.bottom <= windowHeight) {
      banner.classList.remove("sticky-add-to-cart--transparency");
    } else {
      banner.classList.add("sticky-add-to-cart--transparency");
    }
  };

  updateButtonClass();

  window.addEventListener("scroll", updateButtonClass);
  window.addEventListener("resize", updateButtonClass);
});
